module.exports = __webpack_public_path__ + "img/refresh_outlined.dac660d4.svg";